<div class="container plp-homepage">
  <!-- <div class="plp-homepage-header">
    <h5 class="section-head">{{ categoryTypes.name }}</h5>
  </div> -->
  <app-plp-banner></app-plp-banner>
  <div class="plp-homepage-body">
    <div class="row" *ngIf="categoryTypes">
      <div class="col-3" *ngFor="let category of categoryTypes.childCategories">
        <a routerLink="{{ category.url }}" class="plp-homepage-body-item">
          <div class="item-img">
            <img
              class="category-img"
              *ngIf="category.image?.url"
              src="{{ apiurl + category.image?.url }}"
            />
            <cx-media
              class="category-missing-img"
              *ngIf="!category.image?.url"
              [container]="apiurl + category.image?.url"
            >
            </cx-media>
          </div>
          <p class="item-desc">{{ category.name }}</p>
        </a>
      </div>
    </div>
  </div>
</div>
